import { BaseLayout, Navigation } from '@efast_public/fjd-component-library';
import { Outlet, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { LayoutSkeleton } from './LayoutSkeleton';
import { OdmHeader } from './Header/Header';
import ODMFooter from './ODMFooter';
import { ProductResponse, ProfileData } from '../api/user';
import { GovosApiRoutes, govosClient } from '../api/govos-api';
import { RouteKey } from '../pages/AppRoutes';
import { GovOsResult } from '../api/govos.types';

interface LayoutProps {
  isRouteGuardAuthorized?: boolean;
}

export function OdmLayout({ isRouteGuardAuthorized = false }: LayoutProps) {
  const navigate = useNavigate();
  // const location = useLocation();
  const { data: user, isLoading } = useQuery({
    queryKey: [GovosApiRoutes.user()],
    queryFn: () =>
      govosClient
        .get<GovOsResult<ProfileData>>(GovosApiRoutes.user())
        .then((res) => {
          if (res.data.result === 'success') {
            return res.data.data;
          }

          if (isRouteGuardAuthorized) {
            navigate(RouteKey.LOGIN);
          }

          throw new Error('User not found');
        })
  });
  const { data: productResponse } = useQuery<ProductResponse>({
    queryKey: [GovosApiRoutes.products()],
    queryFn: () =>
      govosClient
        .get<ProductResponse>(GovosApiRoutes.products())
        .then((res) => res.data)
  });

  const products = productResponse?.userInfo?.products ?? [];
  // TODO: Routing verbessern

  if (!user && isLoading) {
    return <LayoutSkeleton />;
  }

  if (!user) {
    return (
      <BaseLayout
        header={<OdmHeader user={undefined} products={[]} />}
        mainContentWidth="nearer"
        mainContent={
          <div style={{ minHeight: 'calc(100vh - 86px - 54px - 52px)' }}>
            <Outlet />
          </div>
        }
        footer={<ODMFooter />}
      />
    );
  }

  return (
    <BaseLayout
      header={<OdmHeader user={user} products={products} />}
      mainContentWidth="nearer"
      navigation={
        <Navigation data-testid="navigation">
          <Navigation.NavigationItem
            icon="list"
            label="Online-Dienste"
            selected={window.location.pathname.includes(
              RouteKey.MANAGED_ONLINEDIENSTE
            )}
            onClick={() => navigate(RouteKey.MANAGED_ONLINEDIENSTE)}
          />
          <Navigation.NavigationItem
            icon="person"
            selected={window.location.pathname.includes(
              RouteKey.ZUSTAENDIGE_STELLEN
            )}
            label="Zuständige Stelle(n)"
            onClick={() => navigate(RouteKey.ZUSTAENDIGE_STELLEN)}
          />
          <Navigation.NavigationItem
            icon="document"
            label="Vorlagenverwaltung"
            selected={window.location.pathname.includes(
              RouteKey.TEMPLATE_CONFIGURATION
            )}
            onClick={() => navigate(RouteKey.TEMPLATE_CONFIGURATION)}
          />
        </Navigation>
      }
      mainContent={
        <div style={{ padding: 'var(--fjd2-spacing-l) 0' }}>
          <Outlet />
        </div>
      }
      className="fjd-base-layout__resizeMaxWidth"
      footer={<ODMFooter />}
    />
  );
}
